import Vue from 'vue'
import Router from 'vue-router'

/* Layout */
import Layout from '@/views/layout/Layout'

Vue.use(Router)

/**
* hidden: true                   如果 `hidden:true` 则不会在侧边栏sidebar中显示 (default is false)
* alwaysShow: true               如果设置这个为true 则始终显示根菜单，无论它子路由的长度是多少都不显示
*                                如果没设置alwaysShow这个属性，则子级下只能有一个以上的路由，它就会成为嵌套模式，不然就不显示根菜单

* redirect: noredirect           如果这样设置 `redirect:noredirect` 面包屑breadcrumb中不会重定向
* name:'router-name'             name这个属性由 <keep-alive> 使用  (必须设置！！！)
* meta : {
    title: 'title'               子菜单和面包屑中显示的名称
    icon: 'svg-name'             图标显示在侧边栏sidebar中
    breadcrumb: false            如果为false，则该项将隐藏在breadcrumb中(default is true)
  }
**/
export const constantRouterMap = [{
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: () => import('@/views/redirect/index')
  }]
},
{
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true
},
{
  path: '/auth-redirect',
  component: () => import('@/views/login/authredirect'),
  hidden: true
},
{
  path: '/404',
  component: () => import('@/views/errorPage/404'),
  hidden: true
},
{
  path: '/401',
  component: () => import('@/views/errorPage/401'),
  hidden: true
},
{
  path: '/pdfView',
  component: () => import('@/views/pdfView'),
  hidden: true
},
{
  path: '',
  component: Layout,
  redirect: 'homepage',
  children: [{
    path: 'homepage',
    component: () => import('@/views/dashboard/index'),
    name: 'Dashboard',
    meta: {
      title: 'dashboard',
      icon: 'mdi:home-circle',
      noCache: true,
      affix: true
    }
  }]
},
// 项目管理->所有需求
{
  path: '/allDemand',
  component: Layout,
  redirect: 'allDemand',
  name: 'allDemand',
  meta: {
    title: '需求相关',
    icon: 'table'
  },
  hidden: true,
  children: [{
    path: 'addDemand',
    component: () => import('@/views/projectManagement/allDemands/addDemand.vue'),
    name: 'addDemand',
    meta: {
      title: '新增需求',
      hidden: true
    }
  },
  {
    path: 'editDemand',
    component: () => import('@/views/projectManagement/allDemands/editDemand.vue'),
    name: 'editDemand',
    meta: {
      title: '编辑需求',
      hidden: true
    }
  },
  {
    path: 'changeDemand',
    component: () => import('@/views/projectManagement/allDemands/changeDemand.vue'),
    name: 'changeDemand',
    meta: {
      title: '变更需求',
      hidden: true
    }
  },
  {
    path: 'checkDemand',
    component: () => import('@/views/projectManagement/allDemands/checkDemand'),
    name: 'checkDemand',
    meta: {
      title: '查看需求',
      hidden: true
    }
  },
  {
    path: 'newCheckDemand',
    component: () => import('@/views/projectManagement/allDemands/newCheckDemand'),
    name: 'newCheckDemand',
    meta: {
      title: '查看需求',
      hidden: true
    }
  },
  // 月度报表详情列表
  {
    path: '/checkMonthlyDemend/:demand_date/:id/:type/:total',
    component: () => import('@/views/projectManagement/allDemands/checkMonthlyDemend'),
    name: 'checkMonthlyDemend',
    meta: {
      title: '月度需求详情'
    },
    hidden: true
  },
  {
    path: '/checkKpiDemand/:user_id/:ds_month/:searchDate/:group',
    component: () => import('@/views/projectManagement/allDemands/checkKpiDemand'),
    name: 'checkKpiDemand',
    meta: {
      title: 'KPI需求详情'
    },
    hidden: true
  }
  ]
},

// 所有任务
{
  path: '/allTask',
  component: Layout,
  redirect: 'allTask',
  name: 'allTask',
  meta: {
    title: 'allTasks',
    icon: 'table'
  },
  hidden: true,
  children: [{
    path: 'addTask',
    component: () => import('@/views/projectManagement/allTasks/addTasks'),
    name: 'addTask',
    meta: {
      title: '新增任务',
      hidden: true
    }
  },
  {
    path: 'editTask',
    component: () => import('@/views/projectManagement/allTasks/editTasks'),
    name: 'editTask',
    meta: {
      title: '编辑任务',
      hidden: true
    }
  },
  {
    path: 'rejectedToDevelopmen',
    component: () => import('@/views/projectManagement/allTasks/rejectedToDevelopmen'),
    name: 'rejectedToDevelopmen',
    meta: {
      title: '驳回到开发',
      hidden: true
    }
  },
  {
    path: 'checkTask',
    component: () => import('@/views/projectManagement/allTasks/checkTask'),
    name: 'checkTask',
    meta: {
      title: '查看任务',
      hidden: true
    }
  },
  {
    path: 'newCheckTask',
    component: () => import('@/views/projectManagement/allTasks/newCheckTask'),
    name: 'newCheckTask',
    meta: {
      title: '查看任务',
      hidden: true
    }
  }
  ]
},

// 我的草稿
{
  path: '/myDrafts',
  component: Layout,
  redirect: 'index',
  hidden: true,
  meta: {
    title: '与我有关',
    icon: 'lock',
    hidden: true
  },
  children: [{
    path: 'myDraft',
    component: () => import('@/views/myDraft/index'),
    name: 'myDraft',
    meta: {
      title: '我的草稿',
      hidden: true
    }
  },
  {
    path: 'waitReview',
    component: () => import('@/views/myDraft/waitReview'),
    name: 'waitReview',
    meta: {
      title: '待我审核',
      hidden: true
    }
  },
  {
    path: 'checkDraft',
    component: () => import('@/views/myDraft/checkDraft'),
    name: 'checkDraft',
    meta: {
      title: '查看草稿',
      hidden: true
    }
  },
  {
    path: 'editDrafts',
    component: () => import('@/views/myDraft/editDraft'),
    name: 'editDrafts',
    meta: {
      title: '编辑草稿',
      hidden: true
    }
  }
  ]
},
// 系统->所有产品->产品模块
{
  path: '/system',
  component: Layout,
  redirect: '/system/all_product',
  name: 'system',
  meta: {
    title: 'systemManagement',
    icon: 'table'
  },
  hidden: true,
  children: [{
    path: 'product_module/:project_id/:project_name',
    component: () => import('@/views/systemManagement/productModule'),
    name: 'productModule',
    meta: {
      title: 'productModule'
    },
    hidden: true
  },
  {
    path: 'emailGroups',
    component: () => import('@/views/systemManagement/emailGroups'),
    name: 'emailGroups',
    meta: {
      title: '通讯录',
      hidden: true
    }
  },
  {
    path: '/allModules',
    component: () => import('@/views/systemManagement/allModules'),
    name: 'allModules',
    meta: {
      title: '产品模块'
    },
    hidden: true
  }
    // {
    //   path: 'addDemand',
    //   component: () => import('@/views/projectManagement/allDemands/addDemand.vue'),
    //   name: 'addDemand',
    //   meta: {
    //     title: '新增需求',
    //     hidden: true
    //   }
    // },
    // {
    //   path: 'editDemand',
    //   component: () => import('@/views/projectManagement/allDemands/editDemand.vue'),
    //   name: 'editDemand',
    //   meta: {
    //     title: '编辑需求',
    //     hidden: true
    //   }
    // },
    // {
    //   path: 'changeDemand',
    //   component: () => import('@/views/projectManagement/allDemands/changeDemand.vue'),
    //   name: 'changeDemand',
    //   meta: {
    //     title: '变更需求',
    //     hidden: true
    //   }
    // },
  ]
},
// 版本-版本管理
{
  path: '/versionManagement',
  component: Layout,
  redirect: '/versionManagement',
  name: 'versionManagement',
  meta: {
    title: '版本管理',
    icon: 'table'
  },
  hidden: true,
  children: [{
    path: 'addVersion',
    component: () => import('@/views/version/addVersion'),
    name: 'addVersion',
    meta: {
      title: '新建版本',
      hidden: true
    }
  },
  {
    path: 'editVersion/:pv_id',
    component: () => import('@/views/version/editVersion'),
    name: 'editVersion',
    meta: {
      title: '编辑版本',
      hidden: true
    }
  },
  {
    path: 'lookVersion/:pv_id',
    component: () => import('@/views/version/lookVersion'),
    name: 'lookVersion',
    meta: {
      title: '查看版本',
      hidden: true
    }
  },
  {
    path: 'associatedDemand/:pv_id',
    component: () => import('@/views/version/associatedDemand'),
    name: 'associatedDemand',
    meta: {
      title: '关联需求',
      hidden: true
    }
  },

  {
    path: 'associatedDemandLook/:pv_id',
    component: () => import('@/views/version/associatedDemandLook'),
    name: 'associatedDemandLook',
    meta: {
      title: '查看已关联需求',
      hidden: true
    }
  },
  {
    path: 'decompositionTask/:demand_id',
    component: () => import('@/views/version/decompositionTask'),
    name: 'decompositionTask',
    meta: {
      title: '分解任务',
      hidden: true
    }
  }
  ]
},
// 版本-异常需求
{
  path: '/abnormalDemand',
  component: Layout,
  redirect: '/abnormalDemand',
  name: 'abnormalDemand',
  meta: {
    title: '异常需求',
    icon: 'table'
  },
  hidden: true
},

// 版本-取消关联
{
  path: '/disassociation',
  component: Layout,
  redirect: '/disassociation',
  name: 'disassociation',
  meta: {
    title: '取消关联',
    icon: 'table'
  },
  hidden: true,
  children: [

    {
      path: 'disassociatedDemand/:pv_id',
      component: () => import('@/views/version/disassociatedDemand'),
      name: 'disassociatedDemand',
      meta: {
        title: '取消关联需求',
        hidden: true
      }
    }
  ]
},
// 测试-缺陷管理
{
  path: '/defectManagement',
  component: Layout,
  redirect: '/defectManagement',
  name: 'defectManagement',
  meta: {
    title: '缺陷管理',
    icon: 'table'
  },
  hidden: true,
  children: [{
    path: 'addDefect',
    component: () => import('@/views/test/addDefect'),
    name: 'addDefect',
    meta: {
      title: '新增缺陷',
      hidden: true
    }
  },
  {
    path: 'editDefect/:tb_id',
    component: () => import('@/views/test/editDefect'),
    name: 'editDefect',
    meta: {
      title: '编辑缺陷',
      hidden: true
    }
  },
  {
    path: '/lookDefect/:tb_id',
    component: () => import('@/views/test/lookDefect'),
    name: 'lookDefect',
    meta: {
      title: '查看缺陷',
      hidden: true
    }
  },
  {
    path: '/addDefectXuqiu',
    component: () => import('@/views/test/addDefectXuqiu'),
    name: 'addDefectXuqiu',
    meta: {
      title: '新增缺陷',
      hidden: true
    }
  },
  {
    path: 'editDefectDemand/:tb_id',
    component: () => import('@/views/test/editDefectDemand'),
    name: 'editDefectDemand',
    meta: {
      title: '编辑缺陷',
      hidden: true
    }
  },
  {
    path: 'auditDefect/:tb_id',
    component: () => import('@/views/test/auditDefect'),
    name: 'auditDefect',
    meta: {
      title: '审核缺陷',
      hidden: true
    }
  }
    // children: [{
    //   path: 'Defect',
    //   component: () => import('@/views/test/lookDefect/index0000.vue'),

    //   meta: {
    //     title: '编辑缺陷',
    //     // hidden: true
    //   }
    // }]

  ]
}
  // 测试-任务统计
]

export default new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  // 我的地盘
  // {
  //   path: '/myDraft',
  //   component: Layout,
  //   redirect: '/myDraft/index',
  //   alwaysShow: true, // will always show the root menu
  //   meta: {
  //     title: '我的地盘',
  //     icon: 'lock',
  //     roles: ['admin', 'editor'] // you can set roles in root nav
  //   },
  //   children: [{
  //     path: 'index',
  //     component: () => import('@/views/myDraft/index'),
  //     name: 'myDraft',
  //     meta: {
  //       title: '我的草稿',
  //       roles: ['admin'] // or you can only set roles in sub nav
  //     }
  //   },
  //   {
  //     path: 'editDraft',
  //     component: () => import('@/views/myDraft/editDraft'),
  //     name: 'editDraft',
  //     meta: {
  //       title: '编辑草稿',
  //       roles: ['admin'] // or you can only set roles in sub nav
  //     }
  //   }
  //   ]
  // },
  // // 项目管理
  // {
  //   path: '/projectManagement',
  //   component: Layout,
  //   redirect: '/projectManagement',
  //   alwaysShow: true, // will always show the root menu
  //   meta: {
  //     title: '项目管理',
  //     icon: 'lock',
  //     roles: ['admin', 'editor'] // you can set roles in root nav
  //   },
  //   children: [{
  //     path: 'allDemand',
  //     component: () => import('../views/projectManagement/allDemands/allDemand.vue'),
  //     name: 'allDemand',
  //     meta: {
  //       title: '所有需求',
  //       roles: ['admin'] // or you can only set roles in sub nav
  //     }
  //   },
  //   {
  //     path: 'addDemand',
  //     component: () => import('../views/projectManagement/allDemands/addDemand.vue'),
  //     name: 'addDemand',
  //     meta: {
  //       title: '新增需求',
  //       roles: ['admin'] // or you can only set roles in sub nav
  //     }
  //   },
  //   {
  //     path: 'editDemand',
  //     component: () => import('../views/projectManagement/allDemands/editDemand.vue'),
  //     name: 'editDemand',
  //     meta: {
  //       title: '编辑需求',
  //       roles: ['admin'] // or you can only set roles in sub nav
  //     }
  //   },
  //   {
  //     path: 'changeDemand',
  //     component: () => import('../views/projectManagement/allDemands/changeDemand.vue'),
  //     name: 'changeDemand',
  //     meta: {
  //       title: '变更需求',
  //       roles: ['admin'] // or you can only set roles in sub nav
  //     }
  //   },
  //   {
  //     path: 'allTask',
  //     component: () => import('../views/projectManagement/allTasks/allTask.vue'),
  //     name: 'allTask',
  //     meta: {
  //       title: '所有任务',
  //       roles: ['admin'] // or you can only set roles in sub nav
  //     }
  //   },
  //   {
  //     path: 'addTask',
  //     component: () => import('../views/projectManagement/allTasks/addTasks.vue'),
  //     name: 'addTask',
  //     meta: {
  //       title: '新增任务',
  //       roles: ['admin'] // or you can only set roles in sub nav
  //     }
  //   },
  //   {
  //     path: 'editTask',
  //     component: () => import('../views/projectManagement/allTasks/editTasks.vue'),
  //     name: 'editTask',
  //     meta: {
  //       title: '编辑任务',
  //       roles: ['admin'] // or you can only set roles in sub nav
  //     }
  //   },
  //   {
  //     path: 'rejectedToDevelopmen',
  //     component: () => import('../views/projectManagement/allTasks/rejectedToDevelopmen.vue'),
  //     name: 'rejectedToDevelopmen',
  //     meta: {
  //       title: '驳回到开发',
  //       roles: ['admin'] // or you can only set roles in sub nav
  //     }
  //   }
  //   ]
  // },
  // // 所有任务
  // // {

  // // },

  // /** When your routing table is too long, you can split it into small modules**/
  // // componentsRouter,
  // // tableRouter,
  // testRouter,
  // visionRouter,

  // {
  //   path: '/statistics',
  //   component: Layout,
  //   redirect: '/statistics/edition',
  //   name: 'statistics',
  //   meta: {
  //     title: 'statistics',
  //     icon: 'table'
  //   },
  //   children: [
  //     {
  //       path: 'edition',
  //       component: () => import('@/views/statistics/edition'),
  //       name: 'edition',
  //       meta: { title: 'edition' }
  //     },
  //     {
  //       path: 'product',
  //       component: () => import('@/views/statistics/product'),
  //       name: 'product',
  //       meta: { title: 'product' }
  //     }
  //   ]
  // },
  // {
  //   path: '/system',
  //   component: Layout,
  //   redirect: '/system/all_product',
  //   name: 'system',
  //   meta: {
  //     title: 'systemManagement',
  //     icon: 'table'
  //   },
  //   children: [
  //     {
  //       path: 'all_product',
  //       component: () => import('@/views/systemManagement/allProduct'),
  //       name: 'allProduct',
  //       meta: { title: 'allProduct' },
  //       hidden: true
  //     },
  //     {
  //       path: 'product_module',
  //       component: () => import('@/views/systemManagement/productModule'),
  //       name: 'productModule',
  //       meta: { title: 'productModule' },
  //       hidden: true
  //     }
  //   ]
  // },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export const routerMap = {
  // 我的地盘
  myDraft: () => import('@/views/myDraft/index'),
  checkDraft: () => import('@/views/myDraft/checkDraft'),
  editDrafts: () => import('@/views/myDraft/editDraft'),

  waitReview: () => import('@/views/myDraft/waitReview'),
  // 项目管理
  allDemands: () => import('@/views/projectManagement/allDemands/allDemand'),
  addDemand: () => import('@/views/projectManagement/allDemands/addDemand'),
  editDemand: () => import('@/views/projectManagement/allDemands/editDemand'),
  changeDemand: () => import('@/views/projectManagement/allDemands/changeDemand'),
  allTasks: () => import('@/views/projectManagement/allTasks/allTask'),
  addTask: () => import('@/views/projectManagement/allTasks/addTasks'),
  editTask: () => import('@/views/projectManagement/allTasks/editTasks'),
  rejectedToDevelopmen: () => import('@/views/projectManagement/allTasks/rejectedToDevelopmen'),
  // 统计
  edition: () => import('@/views/statistics/edition'),
  product: () => import('@/views/statistics/product'),
  weekly: () => import('@/views/statistics/weekly'),
  demand: () => import('@/views/statistics/demand'),
  taskStatics: () => import('@/views/statistics/taskStatics.vue'),
  monthlyReport: () => import('@/views/statistics/monthlyReport.vue'),
  kpiView: () => import('@/views/statistics/kpiView.vue'),
  scoreDetail:() => import('@/views/projectManagement/allDemands/scoreDetail'),
  implementation: () => import('@/views/statistics/implementation.vue'),
  // 系统管理
  allProduct: () => import('@/views/systemManagement/allProduct'),
  emailGroups: () => import('@/views/systemManagement/emailGroups'),

  userrightManage: () => import('@/views/systemManagement/userrightManage'),

  // 缺陷管理
  defectManage: () => import('@/views/test/defectManagement'),
  addDefect: () => import('@/views/test/addDefect'),
  editDefect: () => import('@/views/test/editDefect'),

  // 版本:[版本管理][取消关联]
  versionManagement: () => import('@/views/version/versionManagement'),
  abnormalDemands: () => import('@/views/version/abnormalDemand'),
  addVersion: () => import('@/views/version/addVersion'),
  editVersion: () => import('@/views/version/editVersion'),
  associatedDemand: () => import('@/views/version/associatedDemand'),
  associatedDemandLook: () => import('@/views/version/associatedDemandLook'),

  disassociatedDemand: () => import('@/views/version/disassociatedDemand'),
  disassociation: () => import('@/views/version/disassociation/index'),
  decompositionTask: () => import('@/views/version/decompositionTask'),
  demandSource: () => import('@/views/systemManagement/demandSource'),
  uploadCode: () => import('@/views/uploadCode/uploadCode'),
  completionView: () => import('@/views/completionView/index')
}
